import { useParams, Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
import { Wordmark, Footer } from "@/components/Brand";
import { LEGAL_DOCS } from "@/lib/legalContent";

const ORDER = ["terms", "privacy", "ai_use"];
const NAV = { terms: "Terms", privacy: "Privacy", ai_use: "AI Use" };

export default function Legal() {
  const { doc } = useParams();
  const key = LEGAL_DOCS[doc] ? doc : "terms";
  const active = LEGAL_DOCS[key];

  return (
    <div className="min-h-screen bg-wr-bg flex flex-col wr-grid-bg" data-testid="legal-page">
      <header className="border-b border-wr-border bg-black/70 backdrop-blur-xl">
        <div className="max-w-4xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
          <Wordmark size="md" />
          <Link to="/" className="wr-label hover:text-white flex items-center gap-2" data-testid="legal-back-home">
            <ArrowLeft size={14} /> Home
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-8 py-8 sm:py-12">
        <p className="wr-label !text-wr-red flex items-center gap-2"><FileText size={13} /> FOUNDING BETA</p>
        <h1 className="wr-heading font-bold text-white text-3xl sm:text-4xl mt-3" data-testid="legal-title">
          {active.title}
        </h1>
        <p className="wr-mono text-xs text-wr-muted mt-3" data-testid="legal-effective">{active.effective}</p>

        <nav className="mt-6 flex flex-wrap gap-2" data-testid="legal-nav">
          {ORDER.map((d) => (
            <Link
              key={d}
              to={`/legal/${d}`}
              data-testid={`legal-tab-${d}`}
              className={`wr-mono text-xs uppercase tracking-wider px-3 py-2 border ${
                d === key ? "border-wr-red text-white bg-wr-redMuted" : "border-wr-border text-wr-sub hover:text-white"
              }`}
            >
              {NAV[d]}
            </Link>
          ))}
        </nav>

        <div className="mt-8 space-y-6">
          {active.body.map(([heading, text], i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="text-base font-semibold text-white">{heading}</h2>
              <p className="text-sm text-wr-sub mt-1.5 leading-relaxed">{text}</p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
